import { isNil } from "lodash";

export const validateAcademicPricesData = (data: any) => {
  const {
    admissionFee,
    annualFee,
    extraClassFee,
    monthlyFee,
    stationeryFee,
    examFee,
    extraCirculumFee,
    classId,
  } = data;

  let warningMessage = "";

  if (isNil(admissionFee)) {
    warningMessage = "Admission fee is required";
  } else if (isNil(annualFee)) {
    warningMessage = "Annual fee is required";
  } else if (isNil(extraClassFee)) {
    warningMessage = "Extra class fee is required";
  } else if (isNil(monthlyFee)) {
    warningMessage = "Montly fee is required";
  } else if (isNil(stationeryFee)) {
    warningMessage = "Stationary fee is required";
  } else if (isNil(examFee)) {
    warningMessage = "Exam fee is required";
  } else if (isNil(extraCirculumFee)) {
    warningMessage = "Extra circulum fee is required";
  } else if (isNil(classId)) {
    warningMessage = "Class is required";
  }

  return warningMessage;
};
